import { Box, Button, DialogContent, DialogTitle, Divider, List, ListItem, Stack } from '@mui/material';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ApplicationActions, ROBOT_TEMPLATES } from '../../../../utils/constants';
import TemplateCard from './TemplateCard';
import { applicationSlice } from '../../../../redux/ApplicationSlice';
import HelpPopover from '../../../HelpPopover';

interface RobotTemplateDialogProps {
  onClose: () => void;
  open: boolean;
}

const RobotTemplateDialog = ({ onClose }: RobotTemplateDialogProps) => {
  const [robotTemplateKey, setRobotTemplateKey] = useState<string>(ROBOT_TEMPLATES[0].key);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { PROJECT_NAME } = ApplicationActions.Dialogs;

  const handleCancelProject = () => {
    onClose();
  };

  const handleTemplateSelection = (templateKey: string) => {
    setRobotTemplateKey(templateKey);
  };

  const handleNextStep = () => {
    const templateShareCode = ROBOT_TEMPLATES.find((t) => t.key === robotTemplateKey)?.shareCode;
    const dialog = {
      ...PROJECT_NAME,
      options: {
        ...PROJECT_NAME.options,
        title: 'projectNameDialog.new.title',
        projectTemplate: robotTemplateKey,
        rapidRobotCode: templateShareCode,
      },
    };
    dispatch(applicationSlice.actions.onOpenDialog(dialog));
  };

  return (
    <>
      <DialogTitle textAlign="center" position={'relative'}>
        <Trans i18nKey={'robotTemplateDialog.new.title'}>Choose a Robot Template</Trans>
        <Box sx={{ right: 10, top: 10, position: 'absolute' }}>
          <HelpPopover
            id="robot-template-info-popover"
            ariaLabel={t('aria-label.more-info', 'more information')}
            text={t('robotTemplateDialog.tooltip.info', 'Tooltip information about robot templates')}
          />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ width: 500, overflow: 'hidden' }}>
        <Stack direction="column" spacing={2} marginTop={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <List sx={{ maxHeight: 200, overflow: 'auto', minHeight: 400 }}>
            {ROBOT_TEMPLATES.map((template) => (
              <React.Fragment key={template.key}>
                {template.key === 'custom_bot' && (
                  <Divider>
                    <Trans i18nKey={'robotTemplateDialog.or'}>or</Trans>
                  </Divider>
                )}
                <ListItem onClick={() => handleTemplateSelection(template.key)}>
                  <TemplateCard
                    templateKey={template.key}
                    templateTitle={template.title ?? template.key}
                    templateElectronics={template.electronics}
                    selected={robotTemplateKey === template.key}
                  />
                </ListItem>
              </React.Fragment>
            ))}
          </List>

          <Stack direction="row" display="flex" justifyContent="space-between" width={'100%'}>
            <Button onClick={handleCancelProject}>
              <Trans i18nKey="robotTemplateDialog.button.cancel">Cancel</Trans>
            </Button>

            <Button onClick={handleNextStep}>
              <Trans i18nKey="robotTemplateDialog.button.next">Next</Trans>
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </>
  );
};

export default RobotTemplateDialog;
